<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">자주 묻는 질문</h3>
      </v-toolbar>

      <v-flex xs12>
        <v-expansion-panel class="pa-0 pb-0 mt-2 card-shadow small-down-icon">
          <v-expansion-panel-content v-for="(faq, index) in faqs" :key="index" expand-icon="$vuetify.icons.arrowDown">
            <template v-slot:header>
              <v-layout row>
                <span style="font-size: 14px; font-weight: 700; color: #ec2f54; letter-spacing: -0.2px;" class="mr-2">Q.</span>
                <span style="word-break: keep-all; word-wrap: break-word;">{{ faq.question }}</span>
              </v-layout>
            </template>
            <v-divider></v-divider>
            <v-layout>
              <v-card-text v-html="faq.answer"></v-card-text>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'FAQ',
    data () {
      return {
        scrollY: 0,
        faqs: [
          { question: '유스는 어떤 앱인가요?', answer: '유스는 <b>글로벌 유학 커뮤니티 플랫폼</b>이에요. 유학을 꿈꾸는 학생/학부모들이 유학정보를 쉽게 접할 수 있게 하기 위해 유학생들과 그 뜻에 공감하는 사람들이 직접 만들었어요.<br><br>실제 현지 유학생들과 예비유학생/학부모님들을 연결시켜서 유학정보의 비대칭성을 없애고, 누구나 유학을 떠날 수 있는 세상을 만들고자 합니다. 저희는 학생들과 학부모님들이 모두 행복한 멋진 세상을 꿈꿔요. 여러분들의 꿈을 진심으로 응원하며, 최선을 다해 도울게요.' },
          { question: '유스는 어떻게 구성되어 있나요?', answer: '유스는 유저분들께 크게 다음 4가지를 제공해요.<br>1. 현지 유학생들이 직접 쓰는 <b>무료 콘텐츠</b><br>2. 각종 유학정보를 담은 <b>콘텐츠 채널</b><br>3. 다양한 유학 테마로 의사소통할 수 있는 <b>커뮤니티 채널</b><br>4. 유학생들의 삶과 유학전략이 담긴 <b>스토리</b><br><br>모두 메인 화면의 <a href="/" style="text-decoration: underline">투데이</a> 탭에서 하루에 하나씩 추천받을 수 있어요. 관심 가는 채널은 구독하여 두고두고 볼 수 있답니다.<br><br>유스는 매일 정확하고 퀄리티 높은 유학 컨텐츠를 전달하기 위해 노력해요. 또한 여러분이 자유롭게 유학 준비 일상을 공유하거나 질의응답할 수 있도록 의사소통할 수 있는 커뮤니티도 제공하고 있어요. 그리고 전세계에서 모집된 현지 유학생들이 제작한 스토리 영상(유학전략, 입학방법 등이 담긴 영상이에요)도 스토어에서 구매할 수 있어요.<br><br>스토리 영상을 구입하는 데 사용하신 금액은 학생들과 부모님들을 위한 유학 컨텐츠를 생산하는데 재투자하고, 유저분들께 더 나은 서비스를 제공하기 위해 사용되고 있답니다 :)' },
          { question: '유학 정보는 어떻게 찾을 수 있나요?', answer: '관련된 키워드를 검색하여 나오는 채널에 들어가보세요. 무료 콘텐츠를 통해서도 유학 정보를 확인할 수 있고, 의사소통 커뮤니티에서 다른 유저들에게 질문할 수도 있답니다.' },
          // { question: '쿠폰을 받았는데 어떻게 사용하나요?', answer: '앱 하단 더보기 메뉴에 있는 <a href="/coupons" style="text-decoration: underline">보유쿠폰</a> 아이콘을 눌러 보유한 쿠폰을 확인할 수 있습니다. 보유 쿠폰 페이지 우측 상단의 <a href="/coupons/enroll" style="text-decoration: underline">쿠폰 등록하기</a>를 눌러서 쿠폰 코드를 입력해주세요.<br>등록한 쿠폰은 스토어 상품 구매시 사용할 수 있습니다. 쿠폰은 한 상품에 여러 개를 중복해서 사용할 수 없습니다.' },
          { question: '스토어 상품을 환불하고 싶어요. 어떻게 해야 하나요?',
            answer: `아래 지침을 참고하셔서, <a onclick="Kakao.PlusFriend.chat({plusFriendId:'_ygxjIT'});return false;" style="text-decoration: underline">유스 카카오 플러스친구</a> 또는 <a href="/refund-request" style="text-decoration: underline">info@glorang.com</a>으로 <b>회원정보(닉네임, 계정과 연결된 이메일 또는 전화번호)</b>와 <b>환불을 요청하시는 상품, 환불 사유</b>를 함께 작성하여 보내주시면 최대한 빨리 처리해드리겠습니다. 감사합니다.<br><br>` +
              '<b>1. 청약철회 - 스토리</b><br><br>' +
              '<figure><table><tbody><tr style="background-color: #e2e2e2"><td colspan="2" style="text-align: center;"><span>구분</span></td><td><span>키트를 개봉하거나 사용하여<br>상품가치가 현저히 감소된 경우</span></td><td><span>키트를 개봉하거나<br>사용하지 않은 경우</span></td></tr><tr><td style="background-color: #e2e2e2" rowspan="3"><span>공급받은 날로부터<br>7일 이내</span></td><td style="background-color: #f2f2f2"><span>수강권만<br>환불하는 경우</span></td><td colspan="2"><p>수강권 기이용분(정상가 기준)을 계좌이체로 지급해야 결제금액 환불 가능</p><p>* 고객이 키트의 정가를 지급해야 환불 가능</p></td></tr><tr><td style="background-color: #f2f2f2"><span>키트만<br>환불하는 경우</span></td><td><span>청약철회 제한</span></td><td><p>청약철회 가능</p><p>* 고객이 수강권 정상가를 지급 및 본인 택배비 부담으로 키트를 반환해야 결제금액 환불 가능</p></td></tr><tr><td style="background-color: #f2f2f2"><span>수강권과 키트 모두<br>환불하는 경우</span></td><td><p>수강권 기이용분(정상가 기준)을 계좌이체로 지급해야 결제금액 환불 가능</p><p>* 고객이 키트의 정가를 지급해야 환불 가능</p></td><td><p>수강권 기이용분(정상가 기준)을 계좌이체로 지급해야 결제금액 환불 가능</p><p>* 고객이 본인 택배비 부담으로 키트를 반환해야 환불 가능</p></td></tr><tr><td style="background-color: #e2e2e2" rowspan="2"><span>공급받은 날로부터<br>7일 이후</span></td><td style="background-color: #f2f2f2"><span>수강권만<br>환불하는 경우</span></td><td colspan="2"><p>수강권 기이용분(정상가 기준) 및 위약금(최종 결제 금액의 10%)을 계좌이체로 지급해야 결제금액 환불 가능</p><p>* 고객이 키트의 정가를 지급해야 환불 가능</p></td></tr><tr><td style="background-color: #f2f2f2"><span>키트만<br>환불하는 경우</span></td><td colspan="2"><span>청약철회 제한</span></td></tr></tbody></table></figure>' +
              '<br>* 기이용분 = 정상가 X (이용한 강의 수 / 전체 강의 수)<br>* 강의가 재생된 경우 강의 재생 시간에 관계없이 강의를 이용한 것으로 간주합니다.<br>* 수강권의 수강기간은 일시정지할 수 없습니다.<br>* 키트와 함께 주문하신 상품에 대하여, "결제 완료 이후 수강 개시 전"일 때 결제 취소요청을 하신 경우, 배송업체 확인 후 취소절차가 진행됩니다. 배송이 이미 시작된 경우에는 왕복 배송비를 부담하셔야 합니다.<br>* 수업 자료를 다운받았을 경우에는 강의를 이용한 것으로 간주합니다.<br><br><br>' +
              '<b>2. 청약철회 - 컨설팅</b><br><br>공급받은 날부터 7일 이내/상담 진행 전: 수강권 환불 가능<br>공급받은 날부터 7일 이내/상담 진행 후: 청약철회 제한<br>공급받은 날부터 7일 이후/상담 진행 전: 위약금(최종 결제 금액의 10%)을 계좌이체로 지급해야 결제금액 환불 가능<br>공급받은 날부터 7일 이후/상담 진행 후: 청약철회 제한' },
          { question: 'VLOG를 제작중인 유학생입니다. 유스에 제 영상을 공유하려면 어떻게 해야 하나요?', answer: '유스 크리에이터로 지원해주세요!<br><a target="_blank" href="https://www.youthcreator.me" style="text-decoration: underline">www.youthcreator.me</a>에서 유튜버로 지원해 주시면 됩니다.' },
          { question: '유학생인데, 스토리 상품을 제작하고 싶어요. 어떻게 해야 하나요?', answer: '유스 크리에이터로 지원해주세요!<br>자세한 안내와 신청 관련 사항은 <a target="_blank" href="https://www.youthcreator.me" style="text-decoration: underline">www.youthcreator.me</a>에서 확인하실 수 있습니다.' },
          { question: '유스에 건의사항이 있어요!', answer: '<a href="/suggestion" style="text-decoration: underline">제안하기</a>를 통해 의견을 보내주세요. 유스는 유학생의, 유학생에 의한, 유학생을 위한 공간을 지향합니다. 더 나은 유스를 만들기 위한 아이디어를 나눠주세요.' }
        ]
      };
    },
    created () {
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    method: {
      getScrollY () {
        this.scrollY = window.scrollY;
      },
      openKakaoChat () {
        console.log('?');
        // eslint-disable-next-line
        Kakao.PlusFriend.chat({ plusFriendId: '_ygxjIT' });
        return false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }
  /deep/ .v-expansion-panel__header {
    padding: 16px;
  }
  /deep/.small-down-icon {
    .v-expansion-panel__header__icon {
      margin-left: 16px;
      i {
        font-size: 16px;
      }
    }
  }
</style>
